module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "white upload-screen-1-container"
  }, [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "hr-text"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "img-and-caption-container",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "img-container",
    attrs: {
      "xs4": "",
      "md1": ""
    }
  }, [_c('img', {
    attrs: {
      "src": "https://res.cloudinary.com/viewzzz/image/upload/w_auto/v1523306017/dpfvh28om5ef75hlbdtc.jpg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    staticClass: "caption-container",
    attrs: {
      "xs8": "",
      "md11": ""
    }
  }, [_c('textarea', {
    staticClass: "caption-text-area",
    attrs: {
      "placeholder": "Write a caption…"
    }
  })])], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('v-icon', {
    staticClass: "location-icon blue--text"
  }, [_vm._v("keyboard_arrow_right")]), _vm._v(" "), _c('div', {
    staticClass: "input-label text-xs-left "
  }, [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text"
  }, [_vm._v("\n      ISB, Gachibowli, Hyderabad, Telangana 500032, India\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "public-access-toggle blue--text"
  }, [_c('v-switch', {
    model: {
      value: (_vm.switchToggle),
      callback: function($$v) {
        _vm.switchToggle = $$v
      },
      expression: "switchToggle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Public access")]), _vm._v(" "), _c('div', {
    staticClass: "input-container-text"
  }, [_vm._v("\n      Please UNSELECT, if photo was taken from a private property and it is not allowed for everyone to visit this spot.\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "important-details-container"
  }, [_c('div', {
    staticClass: "important-details"
  }, [_vm._v("Important details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Describe emotional appeal")]), _vm._v(" "), _c('input', {
    staticClass: "img-desc-input",
    attrs: {
      "placeholder": "romantic, relaxing, energetic, weird…"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-container"
  }, [_c('div', {
    staticClass: "input-label text-xs-left"
  }, [_vm._v("Photo was taken from")]), _vm._v(" "), _c('input', {
    staticClass: "img-desc-input",
    attrs: {
      "placeholder": "street, bar, hotel room, 4th floor…"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fe02d51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploadScreens/uploadScreen-1.vue
// module id = 828
// module chunks = 1